import React from 'react';
import styled from 'styled-components';
import Txt from '../atoms/Txt';
import Icon from '../atoms/Icon';
import theme from '../../constants/AppTheme';

const MainContainer = styled.div`
  border: 2px solid gray;
  flex: 1;
  display: flex;
  flex-direction: column;
  border-radius: 15px;
  padding: 20px;

  @media (max-width: 768px) {
    width: 400px;
    padding: 10px;
  }
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1px solid gray;
`;

const HeaderButtonsWrap = styled.div`
  display: flex;
  flex-direction: row;
  justify-self: flex-end;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (max-width: 768px) {
    width: 140px;
  }
`;

function HeaderButtons({ tabSelectors = [] }) {
  const tabc = tabSelectors.length;
  let tc = 0;

  return (
    <HeaderButtonsWrap>
      {tabSelectors.map((tab) => {
        tc += 1;
        return (
          <>
            <Txt color={theme.blue} href={tab.url} style={{ marginLeft: 10, marginRight: 10 }}>
              {tab.title}
            </Txt>
            {tc < tabc ? <Txt> | </Txt> : null}
          </>
        );
      })}
    </HeaderButtonsWrap>
  );
}

function TabsContainer({ children, tabs = [], icon_code, title }) {
  return (
    <MainContainer>
      <Header>
        <Icon faCode={icon_code} size={34} color={theme.blue} margin="0 20px 0 10px" />
        <Txt size={20} bold color={theme.blue}>
          {title}
        </Txt>
        <div style={{ flex: 1 }} />
        <HeaderButtons tabSelectors={tabs} />
      </Header>
      <Body>{children}</Body>
    </MainContainer>
  );
}

export default TabsContainer;
